module.exports = __webpack_public_path__ + "static/logo-thewitcher-light-en@2x-256a953d806a41444b29396758fa2e5f.png";